import { useEffect, useRef } from "react";
import { t } from "./i18n.js";

/* ==================== ADSLOT – display-banner-plads ==========================
   Til klassiske AdSense-enheder (IKKE H5 adBreak). Strategien (roadmap 1.5):
   kun på dvæle-skærme, dvs. leaderboard-bunden og præmierummets bund. Aldrig
   i menuen eller spil-views (accidental clicks er hyppigste ban-årsag).

   Gated i tre lag:
   - SLOTS er tomt, indtil AdSense-godkendelsen giver os rigtige ad-unit-id'er
     (oprettes i dashboardet). Uden id: prod renderer INGENTING.
   - Test-mode (localhost eller carnival.adtest) viser en pladsholder med den
     reserverede højde, så layoutet kan vurderes før godkendelsen.
   - Fast min-height reserverer pladsen, så indholdet aldrig hopper (CLS), og
     en tydelig mærkat gør, at banneret aldrig ligner spil-UI.
================================================================================ */

const SLOTS = {
  // udfyldes efter AdSense-godkendelse, fx: leaderboard: "1234567890"
};

const TEST =
  typeof location !== "undefined" &&
  (location.hostname === "localhost" ||
    location.hostname === "127.0.0.1" ||
    !!localStorage.getItem("carnival.adtest"));

export default function AdSlot({ name, height = 100 }) {
  const slotId = SLOTS[name];
  const ref = useRef(null);

  useEffect(() => {
    if (!slotId || !ref.current) return;
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) {}
  }, [slotId]);

  if (!slotId && !TEST) return null;

  return (
    <div className="cv-adslot" style={{ minHeight: height + 18 }}>
      <style>{css}</style>
      <span className="cv-adslot-label">{t("ad_label")}</span>
      {slotId ? (
        <ins
          ref={ref}
          className="adsbygoogle"
          style={{ display: "block", height }}
          data-ad-client="ca-pub-5671941888023653"
          data-ad-slot={slotId}
          data-ad-format="horizontal"
          data-full-width-responsive="true"
        />
      ) : (
        <div className="cv-adslot-ph" style={{ height }}>{t("ad_label")} (test)</div>
      )}
    </div>
  );
}

const css = `
.cv-adslot{
  width:min(96%,520px); margin:18px auto 6px; text-align:center;
}
.cv-adslot-label{
  display:block; font-size:10px; font-weight:800; letter-spacing:1.5px;
  text-transform:uppercase; opacity:.55; margin-bottom:4px;
}
.cv-adslot-ph{
  display:flex; align-items:center; justify-content:center;
  border:2px dashed rgba(255,255,255,.3); border-radius:10px;
  font-size:13px; font-weight:800; opacity:.6;
}
`;
